import { Avatar, Dialog, DialogActions, DialogContent, DialogTitle, Button, CircularProgress, Divider, Fab, Tab, Tabs, Grid, Tooltip, Typography, TextField, Select, MenuItem, InputAdornment, IconButton, Stack, Modal, Table, TableHead, TableRow, TableCell, TableBody, Paper, FormControl, InputLabel, } from "@mui/material";
import ThreeSixtyIcon from "@mui/icons-material/ThreeSixty";
import React, { useState, useEffect, useContext } from "react";
// import clearFilterImage from "../../../src/icons/clearFilter.svg";
import clearFilterImage from "../../../src/icons/clearFilter.svg";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector, GridToolbarExport, GridDensitySelector, getGridStringOperators, } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import SucceedCheck from "../../components/common/LotteStyles/succeedCheck.json";
import searchIcon from "../../icons/searchIcon.svg"

import Drawer from "../../components/common/drawer/drawer";

import { TABS, ROLES, DATE_FORMATS } from "../../constants";

// import ReplaceManagerModal from "../../components/modals/replaceManagerModal";

// import BulkUploadRoleSelector from "../../components/modals/bulkUploadRoleSelector";

// import BulkUserDelete from '../../components/modals/bulkUserDelete';

// import DeletionReasonModal from '../../components/modals/deletionReasonModal';

import moment from "moment";

import { AuthContext } from "../../components/contextAPI/ContextAPI";

import {
  Add,
  AddAPhoto,
  AddTask,
  SaveAlt,
  SaveAltOutlined,
  SaveAs,
  ManageSearch,
  Send,
  Search
} from "@mui/icons-material";

// import { LottiePlayer } from 'lottie-react';

import Lottie from "lottie-react";

import DeletionReasonModal from "../../components/modals/deletionReasonModal";

import { useNavigate } from "react-router-dom";
import UserModal from "../../components/modals/userModal";
import SchoolModal from "../../components/modals/schoolModal";
import DistributorModal from "../../components/modals/distributorModal";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import CommonOtpModal from "../../components/modals/commonOtpModal";
import BulkAddSchool from "../../components/modals/bulkAddSchool";
import BulkAddDistributor from "../../components/modals/bulkAddDistributor";
import CommonOtpModalConsent from "../../components/modals/commonOtpModalConsent";
import "../../App.css";
import { height } from "@mui/system";
import axios from "axios";
import { set } from "date-fns";
import LatLongRequestModal from "../../components/modals/LatLongRequestModal";

const isMobile = window.innerWidth < 900;

const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile &&
  `
      position: relative;
  
      `}
`;

const HeaderContainer = styled.div`
  display: flex;

  align-items: center;

  justify-content: space-between;

  margin-bottom: 7px;
`;

const TableContainer = styled.div`
  //   height: calc(
  //     100vh - ${isMobile
    ? "56px - 20px - 82.23px"
    : "128px - 29px - 50.77px"}
  //   );
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
`;

const DetailsPreviewContainer = styled.div`
  height: 100%;

  width: 100%;

  display: flex;

  justify-content: center;

  align-items: center;

  ${isMobile &&
  `

    height: calc(100vh - 56px - 20px);

  `}
`;

const StyledTabs = styled(Tabs)`
  border-bottom: solid 1px lightGrey;
`;



const DataGridContainer = styled.div`
  max-width: 100%; /* Add this line to limit the width */
  margin: 0 auto; /* Center the content horizontally */
  height: 100%;
  width: 100%;
  //   border: solid 1px lightGrey;
  display: ${isMobile ? "flex" : "grid"};
  border-radius: 4px;

  ${isMobile &&
  `
    flex-direction: column;
  `}
`;


const TabsContainer = styled.div`
  ${isMobile &&
  `

    height: calc(100vh - 56px - 20px - 43.77px);

  `}
`;




const PartyManagement = (props) => {
  const location = useLocation();
  const selectedTabProp1 = location.state?.selectedTabProp;

  const [currentPage, setCurrentPage] = useState(1);
  const [currentPage1, setCurrentPage1] = useState(1);
  const [paginationModel, setPaginationModel] = useState({
    page: currentPage - 1,
    pageSize: 20,
  });
  const [paginationModel1, setPaginationModel1] = useState({
    page: currentPage1 - 1,
    pageSize: 20,
  });
  const [openDialog, setOpenDialog] = useState(false);
  const [reason, setReason] = useState("");
  const [rejectData, setRejectData] = useState(null);
  const [otpVerify, setOtpVerify] = useState(false);
  const [rowCount, setRowCount] = useState();
  const [rowCount1, setRowCount1] = useState();
  const [allRouteNames, setAllRouteNames] = useState([]);
  const [selectedRouteName, setSelectRouteName] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [dateRange1, setDateRange1] = useState(false);
  const [rsms, setRsms] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [asms, setAsms] = useState([]);
  const [rms, setRms] = useState([]);
  const [rm, setRm] = useState("")
  const [rsm, setRsm] = useState("")
  const [asm, setAsm] = useState("")
  const [zh, setZh] = useState("")
  const [zhs, setZhs] = useState([])
  const [consentData, setConsentData] = useState(null);
  const [proceedRms, setProceedRms] = useState([]);
  const navigation = useNavigate();
  const [createdByRM, setCreatedByRm] = useState(false);
  const [userModal, setUserModal] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);
  const [staffMembers, setStaffMembers] = useState([]);
  const [newOrderStatus, setNewOrderStatus] = useState("active");
  const [newOrderStatus1, setNewOrderStatus1] = useState("1");
  const [visibleEmployees, setVisibleEmployees] = useState([]);
  const [categories, setCategories] = useState([]);
  const [board, setBoard] = useState("");
  const [category, setCategory] = useState("");
  const [boards, setBoards] = useState([]);
  const [reasonModalObj, setReasonModalObj] = useState({});

  const [selectedMember, setSelectedMember] = useState(null);

  const [selectedTab, setSelectedTab] = useState(
    selectedTabProp1 || TABS.REGISTERED
  );
  const [showDeletionReasonPicker, setShowDeletionReasonPicker] =
    useState(false);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [allDistricts, setAllDistricts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [accessModulesData, setAccessModulesData] = useState([]);
  const [modalData, setModalData] = useState([]);
  const [selectedSchoolId, setSelectedSchoolId] = useState(null);
  const [pageSize, setPageSize] = useState(20)
  const { auth, setAuth } = useContext(AuthContext);
  const [schoolModal, setSchoolModal] = useState(false);
  const [distributorModal, setDistributorModal] = useState(false);
  const [editSchool, setEditSchool] = useState(false);
  const [editData, setEditData] = useState();
  const [editData1, setEditData1] = useState();
  const [editDistributor, setEditDistributor] = useState(false);
  const [filter, setFilter] = useState(false);
  const [clusters, setClusters] = useState([])
  const [selectedCluster, setSelectedCluster] = useState("")
  const [searchTerm1, setSearchTerm1] = useState(null);
  const [otpModalData, setOtpModalData] = useState();
  const [otpModal1, setOtpModal1] = useState(false);
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
  const [search, setSearch] = useState()
  const [searchPincode, setSearchPincode] = useState("")
  const [letLongRequestModal, setLetLongRequestModal] = useState(false);
  const [otpModalDataDistributor, setOtpModalDataDistributor] = useState();
  const [otpmModalDistributor, setOtpModalDistributor] = useState(false);
  const [bulkSchool, setBulkSchool] = useState(false);
  const [bulkDistributor, setBulkDistributor] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openDistributorViewModal, setOpenDistributorViewModal] = useState(false)
  const [modalDistributorViewData, setModalDistributorViewData] = useState([])
  const [selectedDistributorId, setSelectedDistributorId] = useState(null);
  const [showSwapCheck, setShowSwapCheck] = useState(false)
  const [swapValue, setSwpValue] = useState([])
  const [selectedSchools, setSelectedSchools] = useState([]);
  const [newRows, setNewRows] = useState([])
  const [open, setOpen] = useState(false);
  const [rmForSwap, setRmForSwap] = useState("")
  const [selectAll, setSelecetAll] = useState("0")
  const navigate = useNavigate();

  const consentOtpResend = async (data) => {
    try {
      setLoading(true);
      const response = await window.Platform.database.consentOtpResend({
        partyId: data.schoolId,
      });

      setLoading(false);
      window.NotificationUtils.showSuccess("OTP Sent Successfully");

      // setDistributorModal(false)
      // setEditSchool(false)
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const consentOtpSend = async (data) => {
    try {
      setLoading(true);
      const response = await window.Platform.database.consentOtpSend({
        partyId: data.schoolId,
      });

      setLoading(false);
      window.NotificationUtils.showSuccess("OTP Sent Successfully");

      // setDistributorModal(false)
      // setEditSchool(false)
    } catch (error) {
      console.log(error);
    }
  };
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const consentOtpSubmit = async (data, otp) => {
    try {
      setLoading(true);

      // const response = await window.Platform.database.resendOTP({ mobile: otpModalData1.mobileNo })
      const response = await window.Platform.database.consentOtpSubmit({
        partyId: data.partyId,
        otp: otp,
      });

      setLoading(false);
      window.NotificationUtils.showSuccess("OTP Sent Successfully");

      // setDistributorModal(false)
      // setEditSchool(false)
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (location.state?.selectedTabProp !== undefined) {
      const tab = location.state.selectedTabProp;
      setSelectedTab(tab);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.key, location.pathname, navigate]); // run when the route changes

  const fetchData = async (schoolId) => {
    setLoading(true);
    try {
      const response = await window.Platform.database.getSchoolDataBasedOnId({ schoolId })
      if (response.status == false) {
        setModalData(response?.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setModalData([]);
    }
    setLoading(false);
  };

  async function getSchoolCategory() {
    try {
      setLoading(true);
      let results = await window.Platform.database.getSchoolCategory();
      if (results?.status) {
        window.NotificationUtils.showError(results.message);
        setLoading(false);
      }
      else {
        setCategories(results?.data)
        setLoading(false);
      }
    } catch (error) {
      console.error("ERRORCHECK", error);
      window.NotificationUtils.showError("Error Fetching Data");
      // setLoading(false);
    }
    finally {
      setLoading(false)
    }
  }

  const getBoard = async () => {
    let results = await window.Platform.database.getBoard();
    if (results?.hasError) {
      window.NotificationUtils.showError(results.message);
      setLoading(false);
    }
    else {
      setBoards(results.data);
      setLoading(false);
    }
  }

  const fetchData1 = async (distributorID) => {
    setLoading(true);
    try {
      const response = await window.Platform.database.getDistributorByID({ id: distributorID })
      if (response.status == false) {
        setModalDistributorViewData(response?.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setModalDistributorViewData([]);
    }
    setLoading(false);
  };

  const handleOpenModal = (schoolId) => {
    setSelectedSchoolId(schoolId);
    setOpenModal(true);
    fetchData(schoolId);
  };

  const handleOpenDistributorViewModal = (distributorID) => {
    setSelectedDistributorId(distributorID);
    setOpenDistributorViewModal(true);
    fetchData1(distributorID);
  }
  // const handleCloseModal = () => setOpenModal(false);

  const handleCloseModal = () => {
    setOpenModal(false);
    setModalData([]);
  };

  const handleCloseDistributorViewModal = () => {
    setOpenDistributorViewModal(false);
    setModalDistributorViewData([]);
  }

  useEffect(() => {
    setVisibleEmployees([]);
    setHasSearched(false);
    setRsm("");
    setZh("");
    setAsm("");
    setRm("");
    setSearch("");
    setSearchPincode("");
    setSelectedCluster("");
    setSelectedDistrict("");
    setSelectRouteName("");
    setCreatedByRm(false);
    setSelectedSchools([]);
    setSelecetAll("0");
    setFilter(false);
    setNewOrderStatus("active")
    setNewOrderStatus1("1");
  }, [selectedTab])

  useEffect(() => {
    setShowSwapCheck(false);
    if (!filter) {
      if (selectAll == "1") {
        setSelecetAll("1")
      }
      if (hasSearched) {
        fetchEmployees();
      }
    }
  }, [paginationModel.page, paginationModel1.page, paginationModel.pageSize, paginationModel1.pageSize]);

  useEffect(() => {
    if (hasSearched) {
      fetchEmployees();
    }
  }, [newOrderStatus, newOrderStatus1])

  useEffect(() => {
    fetchAccessModules();
    getClusterInPicklist()
    getSchoolCategory();
    getBoard();
    getAllRouteNames()
    allDistrictsDropdown()
    if (userData?.role.toLowerCase().includes('admin')) {
      getAllUsers()
    }
    if (userData?.role == 'zh') {
      getUsers('zh', userData?.id)
    }
    if (userData?.role == 'rsm') {
      getUsers('rsm', userData?.id)
    }
    if (userData?.role == 'asm') {
      getUsers('asm', userData?.id)
    }
  }, [])

  async function getAllUsers() {
    let results = await window.Platform.database.fetchEmployees()
    if (results?.status) {
      window.NotificationUtils.showError(results.message);
      setLoading(false);
      return;
    }
    else {
      setAllUsers(results?.data)
      setZhs(results?.data?.filter((ele) => ele.role.toLowerCase() == 'zh'))
      setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
      setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
      setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
      setProceedRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
      setLoading(false);
    }
  }


  async function getUsers(role, id) {
    if (id != "") {
      let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
      if (role == 'rsm') {
        // setAsms(results?.data)
        setZhs(results?.data?.filter((ele) => ele.role == "zh"))
        setAsms(results?.data?.filter((ele) => ele.role == 'asm'))
        setRms(results?.data1)
      }
      if (role == 'zh') {
        setAsms(results?.data?.filter((ele) => ele.role == 'asm'))
        setRms(results?.data1)
      }
      if (role == 'asm') {
        setRms(results?.data)
      }
    } else {
      if (role == 'zh') {
        setAsm("")
        setRm("")
        // setRsms(allUsers?.filter((ele) => ele.role == 'rsm'))
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
        setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
      }
      if (role == 'rsm') {
        setRm("")
        setAsm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
        setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
        setZhs(allUsers?.filter((ele) => ele.role == "zh"))
      }

      if (role == 'asm') {
        setRm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
      }
    }

  }
  let contextState = { ...auth };

  const formatTimeStamp = (timestampFromDB) => {
    const options = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true, // Use 12-hour clock
    };

    const formattedDate = new Date(timestampFromDB).toLocaleString(
      "en-US",
      options
    );

    return formattedDate;
  };

  const handleSelectAll = (e) => {

    setSelecetAll("1")
    if (e.target.checked) {
      const allSchoolIds = newRows.map((row) => row.schoolId);
      setSelectedSchools(allSchoolIds);
    } else {
      setSelecetAll("0")
      setSelectedSchools([]);
    }
  };

  const formatTime12 = (timeStr) => {
    if (!timeStr) return "N/A";
    const [hour, minute] = timeStr.split(":");
    let h = parseInt(hour, 10);
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12;
    if (h === 0) h = 12;
    return `${h}:${minute} ${ampm}`;
  };

  // const handleSelectAll = (e) => {
  //   const isChecked = e.target.checked;
  //   setSelecetAll("1");

  //   if (selectAll == "1") {
  //     const allIds = newRows.map((item) => item.schoolId);
  //     setSelectedSchools(allIds);
  //   } else {
  //     setSelectedSchools([]);
  //   }
  // };

  const handleCheckboxChange = (e, schoolId) => {
    const isChecked = e.target.checked;
    if (e.target.checked) {
      setSelectedSchools((prev) => [...prev, schoolId]);
    } else {
      setSelectedSchools((prev) => prev.filter((id) => id !== schoolId));
    }
    if (!isChecked) {
      setSelecetAll("0");
    }
  };
  const schoolColumns = () => {
    const stringOperators = getGridStringOperators().filter((op) =>
      ["contains"].includes(op.value)
    );

    let result = [
      showSwapCheck && {
        field: "Swap",
        headerName: (
          <>
            <input
              type="checkbox"
              onChange={handleSelectAll}
              checked={selectAll == "1" ? true : false}
              // checked={selectedSchools.length === newRows.length && newRows.length > 0}
              width={"30"}
            />
          </>
        ),
        width: 30,
        filterable: false,
        sortable: false,
        renderCell: (params) => (
          <input
            type="checkbox"
            checked={selectedSchools.includes(params.row.schoolId)}
            onChange={(e) => handleCheckboxChange(e, params.row.schoolId)}
            style={{
              // width: "100%",
              // padding: "4px",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
          />
        ),
      },

      // {
      //   field: "schoolId12",
      //   headerName: "School Id",
      //   width: 200,
      //   filterable: false,
      //   sortable: false,
      //   valueGetter: (params) => {
      //     let name = params.row.schoolId
      //     return name;
      //   },
      //   renderCell: (params) => {
      //     let name = params.row.schoolId;
      //     const notVisited = params.row.visitHappened.toLowerCase() === "no";
      //     return (
      //       <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      //         <Tooltip title={name || "N/A"}>
      //           <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name}</Typography>
      //         </Tooltip>
      //         {notVisited && (
      //           <span style={{
      //             background: '#ffcccc',
      //             color: '#d32f2f',
      //             borderRadius: 6,
      //             display:"flex",
      //             float:"right",
      //             fontSize: 10,
      //             padding: '2px 3px 2px 3px',
      //             margin: "5px 0px 0px 2px",
      //             fontWeight: 600,
      //             letterSpacing: 0.2
      //           }}>Not Visited</span>
      //         )}
      //       </div>
      //     );
      //   },
      // },
      {
        field: "schoolId12",
        headerName: "School Id",
        width: 200,
        filterable: false,
        sortable: false,
        valueGetter: (params) => {
          return params.row.schoolId;
        },
        renderCell: (params) => {
          const name = params.row.schoolId;
          const notVisited = params.row.visitHappened?.toLowerCase() === "no";
          const yesVisited = params.row.visitHappened?.toLowerCase() === "yes";

          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between", // pushes badge to right
                width: "100%",
              }}
            >
              <Tooltip title={name || "N/A"}>
                <Typography
                  variant="inherit"
                  sx={{
                    color: "black",
                    fontSize: "11px",
                    fontWeight: "500",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "100px", // prevent overlap with badge
                  }}
                >
                  {name}
                </Typography>
              </Tooltip>

              {notVisited && (
                <span
                  style={{
                    background: "#ffcccc",
                    color: "#d32f2f",
                    borderRadius: 6,
                    fontSize: 10,
                    padding: "2px 4px",
                    fontWeight: 600,
                    letterSpacing: 0.2,
                    whiteSpace: "nowrap",
                  }}
                >
                  Not Visited
                </span>
              )}
              {yesVisited && (
                <span
                  style={{
                    background: "#cefaceff",
                    color: "#2e7d32",
                    borderRadius: 6,
                    fontSize: 10,
                    padding: "2px 4px",
                    width: "71px",
                    fontWeight: 600,
                    letterSpacing: 0.2,
                    whiteSpace: "nowrap",
                  }}
                >
                  Visited
                </span>
              )}
            </div>
          );
        },
      },
      {
        field: "schoolName",

        headerName: "Name",

        minWidth: 260,

        valueGetter: (params) => {
          let name = params.row?.schoolName;
          return name?.split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
            .join(" ");
        },

        flex: 0.22,

        sortable: false,
        filterOperators: stringOperators,
        renderCell: (params) => {
          let name = params.row?.schoolName?.split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
            .join(" ") || "N/A";

          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
            </Tooltip>
          );
        },
      },

      {
        field: "name",

        headerName: "Assigned To",

        minWidth: 150,

        valueGetter: (params) => {
          let name = params.row.ownerName;
          return name;
        },

        flex: 0.22,

        sortable: false,
        filterOperators: stringOperators,
        renderCell: (params) => {
          let name = params.row.ownerName || "N/A";

          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
            </Tooltip>
          );
        },
      },


      {
        field: "makerName",

        headerName: "Decision Maker Name",

        minWidth: 170,

        flex: 0.35,

        sortable: false,
        filterable: false,

        renderCell: (params) => {
          return (
            <Tooltip title={params.row.makerName || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                {params.row.makerName || "N/A"}
              </Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "routeName",
        headerName: "Route Name",
        minWidth: 100,
        // flex: 0.35,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          return (
            <Tooltip title={params.row.routeName || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                {params.row.routeName || "N/A"}
              </Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "View",
        headerName: "View",
        minWidth: 110,
        flex: 0.17,
        sortable: false,
        renderCell: (params) => {
          return (
            <>
              <Tooltip>
                <span>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleOpenModal(params.row.schoolId)}
                    sx={{ minWidth: "80px" }}
                  >
                    {"View"}
                  </Button>
                </span>
              </Tooltip>
              <Modal open={openModal} onClose={handleCloseModal}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "80%",
                    maxWidth: 900,
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    maxHeight: "90%",
                    overflowY: "auto",
                  }}
                >
                  <Typography variant="h6" component="h2" mb={5} style={{ textAlign: "center" }}>
                    School Details
                  </Typography>
                  <div>
                    <div className="row mb-2 mt-1">
                      <div className="col-md-6">
                        <b> School Id:</b> {modalData && modalData[0]?.schoolId || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b> School Name: </b>{modalData && modalData[0]?.schoolName || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-2 mt-1">
                      <div className="col-md-6">
                        <b> Assigned To :</b> {modalData && modalData[0]?.ownerName || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b> Customer Type : </b>{modalData && modalData[0]?.customerType || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-md-6">
                        <b>E-Mail :</b> {modalData && modalData[0]?.email || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>Created At :</b> {modalData && modalData[0]?.createdAt
                          ? new Date(modalData[0].createdAt).toLocaleDateString('en-GB', {
                            day: 'numeric',
                            month: 'short',
                            year: 'numeric'
                          })
                          : "N/A"}
                      </div>

                    </div>
                    <div className="row mb-2">
                      <div className="col-md-6">
                        <b>Customer Type :</b> {modalData && modalData[0]?.customer_type || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>School Type :</b> {modalData && modalData[0]?.schoolTypeName || modalData[0]?.school_type || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-md-6">
                        <b>Decision Maker name :</b> {modalData && modalData[0]?.makerName || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>Decision Maker Contact :</b> {modalData && modalData[0]?.makerContact || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-md-6">
                        <b>Decision Maker Role :</b> {modalData && modalData[0]?.roleName || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>Board :</b> {modalData && modalData[0]?.boardName || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-md-6">
                        <b>Medium : </b> {modalData && modalData[0]?.mediumName || modalData[0]?.medium || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b> Grade :</b> {modalData && modalData[0]?.grade_names || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-md-6">
                        <b>Category :</b> {modalData && modalData[0]?.schoolCategoryName || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>Parent School : </b> {modalData && modalData[0]?.parentSchoolName || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-md-6">
                        <b>Route Name : </b> {modalData && modalData[0]?.routeName || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b> Party Source :</b> {modalData && modalData[0]?.partySourceName || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-md-6">
                        <b>School Start Time :</b> {modalData && modalData[0]?.start_time ? formatTime12(modalData[0].start_time) : "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>School End Time :</b> {modalData && modalData[0]?.end_time ? formatTime12(modalData[0].end_time) : "N/A"}
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-md-6">
                        <b>Strength :</b> {modalData && modalData[0]?.strength || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b> Transporter Name :</b> {modalData && modalData[0]?.transporter_name || "N/A"}
                      </div>

                    </div>
                    <div className="row mb-2">
                      <div className="col-md-6">
                        <b>Address :</b> {modalData && modalData[0]?.AddressLine1 || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>Pincode :</b> {modalData && modalData[0]?.Pincode || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-md-6">
                        <b> District :</b> {modalData && modalData[0]?.District || "N/A"}
                      </div>

                      <div className="col-md-6">
                        <b>State :</b> {modalData && modalData[0]?.State || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-2">

                    </div>
                  </div>
                  <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button onClick={handleCloseModal} variant="contained" color="primary">
                      Close
                    </Button>
                  </Box>
                </Box>
              </Modal>
            </>
          );
        },
      },
      {
        field: "actionByName1",
        headerName: "Action Taken By",
        minWidth: 150,
        // flex: 0.35,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          return (
            <Tooltip title={params.row.actionByName || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                {params.row.actionByName || "N/A"}
              </Typography>
            </Tooltip>
          );
        },
      },

      {
        field: "action_remark",
        headerName: "Action Remark",
        minWidth: 200,
        // flex: 0.35,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          return (
            <Tooltip title={params.row.action_remark || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                {params.row.action_remark || "N/A"}
              </Typography>
            </Tooltip>
          );
        },
      },

      accessModulesData && accessModulesData[0]?.is_approve?.toLowerCase() != "no" && {
        field: "Approve Order",
        headerName: "Actions ",
        width: 200,
        // height: 10,
        // headerAlign: 'center',
        sortable: false,
        // editable: true,
        filterable: false,
        disableExport: true,
        renderCell: (params) => {
          let value = params.row?.schoolId;

          return (
            <Stack direction={"row"} spacing={1}>
              <Tooltip>
                <IconButton onClick={() => handleEdit(params)} title={"Click to Edit School"}>
                  <DriveFileRenameOutlineIcon sx={{ color: "black", fontSize: "22px", fontWeight: "500" }} />
                </IconButton>
              </Tooltip>
              {userData?.role == "super admin" && <Tooltip>
                {/* <IconButton title={"Click to inactive School"}
                  onClick={(e) => handleDelete(params.row.schoolId, e)}
                >
                  <DeleteIcon sx={{ color: "red", fontSize: "22px", fontWeight: "500" }} /> inactive
                </IconButton> */}
                {newOrderStatus == "active" ? <Button variant="contained" color="error" onClick={(e) => handleDelete(params.row.schoolId, e)}>
                  Inactive
                </Button>
                  :
                  <Button variant="contained" color="success" onClick={(e) => handleDelete(params.row.schoolId, e)}>
                    Active
                  </Button>}
              </Tooltip>}
              {/* <Tooltip title="Click to approve school"><IconButton disabled={params.row?.approveStatus === 1 || params.row?.approveStatus === 2} variant="extended" sx={{ color: "#008000" }} onClick={(e) => {
                                e.stopPropagation();
                                approveRejectOrder({ id: value, approvalStatus: "1" });
                            }} >
                                <ThumbUpIcon />
                            </IconButton></Tooltip>


                            <Tooltip title="Click to reject school"><IconButton disabled={params.row?.approveStatus === 1 || params.row?.approveStatus === 2} variant="extended" sx={{ color: "red" }} onClick={(e) => {
                                e.stopPropagation();
                                approveRejectOrder({ id: value, approvalStatus: "2" });
                            }} >
                                <ThumbDownIcon />
                            </IconButton></Tooltip> */}
            </Stack>
          );
        },
      },

      // {
      //     field: "Consent",
      //     headerName: "Consent",
      //     width: 120,
      //     // height: 10,
      //     // headerAlign: 'center',
      //     sortable: false,
      //     // editable: true,
      //     filterable: false,
      //     disableExport: true,
      //     renderCell: (params) => {

      //         let value = params.row?.consent

      //         return (
      //             <Stack direction={"row"} spacing={1}>
      //                 <Tooltip title={"Consent Approval"}>

      //                     <IconButton disabled={params.row.consent || !params.row.makerContact?.length} onClick={() =>{
      //                         setConsentData(params.row)
      //                         updateConsent(params.row)}} >
      //                         <Send />
      //                     </IconButton>

      //                 </Tooltip>
      //                 {/* <Tooltip title="Click "><IconButton disabled={params.row?.approveStatus===1||params.row?.approveStatus===2} variant="extended" sx={{color:"#008000"}}  onClick={(e) => {
      //       e.stopPropagation();
      //       approveRejectOrder({id:value,approvalStatus:"1"});}} >
      //      <ThumbUpIcon/>
      //     </IconButton></Tooltip> */}
      //                 {/* <Tooltip title="Click to reject school"><IconButton disabled={params.row?.approveStatus===1||params.row?.approveStatus===2} variant="extended" sx={{color:"red"}} onClick={(e) => {
      //       e.stopPropagation();
      //       approveRejectOrder({id:value,approvalStatus:"2"});}} >
      //      <ThumbDownIcon/>
      //     </IconButton></Tooltip> */}
      //             </Stack>
      //         )

      //     },
      // },
      // {

      //     field: "Consent Status",

      //     headerName: "Consent Status",

      //     editable: false,

      //     hide: true,

      //     minWidth: 150,
      //     filterable: false,

      //     valueGetter: (params) => {

      //         let name = params.row.consent ? 'true' : 'false';

      //         return name;

      //     },

      //     renderCell: (params) => {

      //         let name = params.row.consent ? 'true' : 'false';

      //         return (

      //             <Tooltip title={name || "N/A"}>

      //                 <Typography variant="inherit">{name === 'true' ? 'Active' : 'Inactive'}</Typography>

      //             </Tooltip>

      //         )

      //     },

      // },
    ].filter(Boolean);
    return result;
  };

  const distributorColumn = () => {
    const stringOperators = getGridStringOperators().filter((op) =>
      ["contains"].includes(op.value)
    );

    let result = [
      // {
      //   field: "distributorid",
      //   headerName: "Distributor Id",
      //   width: 130,
      //   filterable: false,

      //   // height: 10,
      //   // headerAlign: 'center',
      //   sortable: false,
      //   // editable: true,
      //   renderCell: (params) => {
      //     let name = params.row.distributorID;

      //     return (
      //       <Tooltip title={name || "N/A"}>
      //         <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
      //       </Tooltip>
      //     );
      //   },
      // },
      {
        field: "dist12",
        headerName: "Distributor Id",
        width: 200,
        filterable: false,
        sortable: false,
        valueGetter: (params) => {
          return params.row.distributorID;
        },
        renderCell: (params) => {
          const name = params.row.distributorID;
          const notVisited = params.row.visitHappened?.toLowerCase() === "no";
          const yesVisited = params.row.visitHappened?.toLowerCase() === "yes";
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between", // pushes badge to right
                width: "100%",
              }}
            >
              <Tooltip title={name || "N/A"}>
                <Typography
                  variant="inherit"
                  sx={{
                    color: "black",
                    fontSize: "11px",
                    fontWeight: "500",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "100px", // prevent overlap with badge
                  }}
                >
                  {name}
                </Typography>
              </Tooltip>

              {notVisited && (
                <span
                  style={{
                    background: "#ffcccc",
                    color: "#d32f2f",
                    borderRadius: 6,
                    fontSize: 10,
                    padding: "2px 4px",
                    fontWeight: 600,
                    letterSpacing: 0.2,
                    whiteSpace: "nowrap",
                  }}
                >
                  Not Visited
                </span>
              )}
              {yesVisited && (
                <span
                  style={{
                    background: "#cefaceff",
                    color: "#2e7d32",
                    borderRadius: 6,
                    fontSize: 10,
                    padding: "2px 4px",
                    width: "71px",
                    fontWeight: 600,
                    letterSpacing: 0.2,
                    whiteSpace: "nowrap",
                  }}
                >
                  Visited
                </span>
              )}
            </div>
          );
        },
      },

      {
        field: "DistributorName",

        headerName: "Name",

        minWidth: 220,

        valueGetter: (params) => {
          let name = params.row.DistributorName;

          return name?.split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" ");
        },

        // flex: 0.22,

        sortable: false,
        filterOperators: stringOperators,
        renderCell: (params) => {
          let name = params.row.DistributorName?.split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" ") || "N/A";

          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "name",

        headerName: "Assigned To",

        minWidth: 250,

        // flex: 0.22,

        sortable: false,
        filterOperators: stringOperators,
        renderCell: (params) => {
          return (
            <Tooltip title={params.row.name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                {params.row.name || "N/A"}
              </Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "makerName",

        headerName: "Decision Maker Name",

        minWidth: 220,

        // flex: 0.35,

        sortable: false,
        filterable: false,

        valueGetter: (params) => {
          let name = params.row.makerName;

          if (name == null || name?.length == 0) name = "N/A";

          return name;
        },

        renderCell: (params) => {
          let name = params.row.makerName;

          if (name == null || name?.length == 0) name = "N/A";

          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "View",
        headerName: "View",
        minWidth: 100,
        // flex: 0.17,
        sortable: false,
        renderCell: (params) => {
          return (
            <>
              <Tooltip>
                <span>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleOpenDistributorViewModal(params.row.distributorID)}
                    sx={{ minWidth: "80px" }}
                  >
                    {"View"}
                  </Button>
                </span>
              </Tooltip>
              <Modal open={openDistributorViewModal} onClose={handleCloseDistributorViewModal}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "80%",
                    maxWidth: 900,
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    maxHeight: "90%",
                    overflowY: "auto",
                  }}
                >
                  <Typography variant="h6" component="h2" mb={5} style={{ textAlign: "center" }}>
                    Distributor Details
                  </Typography>
                  <div>
                    <div className="row mb-4 mt-2">
                      <div className="col-md-6">
                        <b> Distributor Id:</b> {modalDistributorViewData && modalDistributorViewData[0]?.distributorID || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b> Party Name : </b>{modalDistributorViewData && modalDistributorViewData[0]?.DistributorName || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-4">
                      <div className="col-md-6">
                        <b>Sub Distributor Name : </b> {modalDistributorViewData && modalDistributorViewData[0]?.subDistributorName || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>E-Mail :</b> {modalDistributorViewData && modalDistributorViewData[0]?.email || "N/A"}
                      </div>

                    </div>
                    <div className="row mb-4">
                      <div className="col-md-6">{console.log(modalDistributorViewData, "modalDistributorViewData")}
                        <b>Created At :</b> {modalDistributorViewData && modalDistributorViewData[0]?.createdAt ? new Date(modalDistributorViewData[0].createdAt).toLocaleDateString('en-GB', {
                          day: 'numeric',
                          month: 'short',
                          year: 'numeric'
                        })
                          : "N/A" || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>Decision Maker name :</b> {modalDistributorViewData && modalDistributorViewData[0]?.makerName || "N/A"}
                      </div>

                    </div>

                    <div className="row mb-4">
                      <div className="col-md-6">
                        <b>Decision Maker Contact :</b> {modalDistributorViewData && modalDistributorViewData[0]?.makerContact || "N/A"}
                      </div>
                      <div className="col-md-6">
                        {/* <b>Decision Maker Role :</b> {modalDistributorViewData && modalDistributorViewData[0]?.decisionMakerRole || "N/A"} */}
                      </div>

                    </div>
                    <div className="row mb-4">
                      <div className="col-md-6">
                        <b> Transporter Name :</b> {modalDistributorViewData && modalDistributorViewData[0]?.transporter_name || "N/A"}
                      </div>

                      <div className="col-md-6">
                        <b>Area Name :</b> {modalDistributorViewData && modalDistributorViewData[0]?.cluster_name || "N/A"}
                      </div>

                    </div>
                    <div className="row mb-4">
                      <div className="col-md-6">
                        <b>Pan Card Number :</b> {modalDistributorViewData && modalDistributorViewData[0]?.panNumber || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>Pincode :</b> {modalDistributorViewData && modalDistributorViewData[0]?.Pincode || "N/A"}
                      </div>



                    </div>
                    <div className="row mb-4">
                      <div className="col-12">
                        <b>Address   : </b> {modalDistributorViewData && modalDistributorViewData[0]?.AddressLine1 || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-4">
                      <div className="col-md-6">
                        <b> District :</b> {modalDistributorViewData && modalDistributorViewData[0]?.District || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>State :</b> {modalDistributorViewData && modalDistributorViewData[0]?.State || "N/A"}
                      </div>
                    </div>

                  </div>
                  <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button onClick={handleCloseDistributorViewModal} variant="contained" color="primary">
                      Close
                    </Button>
                  </Box>
                </Box>
              </Modal>
            </>
          );
        },
      },
         {
        field: "actionByName1",
        headerName: "Action Taken By",
        minWidth: 150,
        // flex: 0.35,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          return (
            <Tooltip title={params.row.actionByName || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                {params.row.actionByName || "N/A"}
              </Typography>
            </Tooltip>
          );
        },
      },

      {
        field: "action_remark",
        headerName: "Action Remark",
        minWidth: 200,
        // flex: 0.35,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          return (
            <Tooltip title={params.row.action_remark || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                {params.row.action_remark || "N/A"}
              </Typography>
            </Tooltip>
          );
        },
      },

      accessModulesData && accessModulesData[0]?.is_approve?.toLowerCase() != "no" && {
        field: "Approve Order",
        headerName: "Actions ",
        width: 200,
        // height: 10,
        // headerAlign: 'center',
        sortable: false,
        // editable: true,
        filterable: false,
        disableExport: true,
        renderCell: (params) => {
          let value = params.row?.distributorID;

          return (
            <Stack direction={"row"} spacing={1}>
              <Tooltip title="Convert Distributor to Stockist">
                <IconButton
                  onClick={() => handleConvertStockist(params)}
                  style={{
                    //   transform: rotate ? 'rotate(360deg)' : 'rotate(0deg)',
                    transition: "transform 0.6s ease",
                  }}
                >
                  <SwapVertIcon sx={{ color: "black", fontSize: "22px", fontWeight: "500" }} />
                </IconButton>
              </Tooltip>
              <Tooltip title={"Edit Distributor"}>
                <IconButton onClick={() => handleEdit1(params)}>
                  <DriveFileRenameOutlineIcon sx={{ color: "black", fontSize: "22px", fontWeight: "500" }} />
                </IconButton>
              </Tooltip>
              {userData?.role == "super admin" && <Tooltip>
                {/* <IconButton
                  color="black"
                  onClick={(e) =>
                    handleDeleteDistributor(params.row.distributorID, e)
                  }
                >
                  <DeleteIcon sx={{ color: "red", fontSize: "22px", fontWeight: "500" }} />
                </IconButton> */}
                {newOrderStatus1 == "1" ? <Button variant="contained" color="error" onClick={(e) => handleDeleteDistributor(params.row.distributorID, e)}>
                  Inactive
                </Button>
                  :
                  <Button variant="contained" color="success" onClick={(e) => handleDeleteDistributor(params.row.distributorID, e)}>
                    Active
                  </Button>}
              </Tooltip>}
              {/* <Tooltip title="Click to approve distributor"><IconButton disabled={params.row?.approveStatus === 1 || params.row?.approveStatus === 2} variant="extended" sx={{ color: "#008000" }} onClick={(e) => {
                                e.stopPropagation();
                                approveRejectOrder({ id: value, approvalStatus: "1" });
                            }} >
                                <ThumbUpIcon />
                            </IconButton></Tooltip>
                            <Tooltip title="Click to reject distributor"><IconButton disabled={params.row?.approveStatus === 1 || params.row?.approveStatus === 2} variant="extended" sx={{ color: "red" }} onClick={(e) => {
                                e.stopPropagation();
                                approveRejectOrder({ id: value, approvalStatus: "2" });
                            }} >
                                <ThumbDownIcon />
                            </IconButton></Tooltip> */}
            </Stack>
          );
        },
      },
    ];
    return result;
  };

  // const handleEdit1 = (data) => {
  //   setEditDistributor(true);
  //   setEditData1(data.row);
  // };
  const handleEdit1 = (data) => {
    setEditDistributor(true);
    setEditData1(data.row);
    navigate("/distribution", { state: { mode: "edit", row: data.row } });   ////////////////// only this line
  };

  const handleConvertStockist = async (data) => {
    // Show confirmation dialog
    const isConfirmed = window.confirm(
      "Are you sure you want to convert this distributor into a stockist ?"
    );

    if (isConfirmed) {

      const results = await window.Platform.database.addDistributorToStockist({
        distributorId: data?.row?.distributorID,
      });

      if (results.status == false) {
        alert(results.message); // Success 
        window.NotificationUtils.showSuccess(results.message);
      } else {
        alert(results.message); // failure
        window.NotificationUtils.showError(results.message);

      }
    }
  };

  // const handleEdit = async (data) => {
  //   let data11 = {
  //     schoolId: data.row.schoolId
  //   }
  //   const response = await window.Platform.database.getSchoolDataBasedOnId(data11)
  //   setEditSchool(true);
  //   setEditData(response?.data);
  // };

  const handleEdit = async (data) => {
    let data11 = {
      schoolId: data.row.schoolId
    }
    const response = await window.Platform.database.getSchoolDataBasedOnId(data11)
    // setEditSchool(true);
    // setEditData(response?.data);

    // Navigate to `/school` and send the school data using state
    navigate('/school', { state: { editData: response?.data, isEdit: true } });
  };

  //     const handleConfirmReject = () => {
  //   if (reason.trim() === "") {
  //     window.NotificationUtils.showError("Remark is required to reject the order.")
  //     return;
  //   }
  //   approveRejectOrder({ reason });
  //   setOpenDialog(false);
  //   setReason("");
  //   setRejectData(null);
  // };

  const handleConfirmReject = () => {
    const cleanedRemark = reason.trim().replace(/\s+/g, " ");
    if (!cleanedRemark) {
      window.NotificationUtils.showError("Remark is required.");
      return;
    }
    if (cleanedRemark.length < 20) {
      window.NotificationUtils.showError("Remark must be at least 20 characters long.");
      return;
    }
    approveRejectOrder({ reason: cleanedRemark });
    setOpenDialog(false);
    setReason("");
    setRejectData(null);
  };


  const handleDelete = (data) => {
    setRejectData(data);
    setOpenDialog(true);
  };

  const handleDeleteDistributor = (data) => {
    setRejectData(data);
    setOpenDialog(true);
  }

  // const handleDeleteDistributor = async (distributorId, event) => {
  //   event.stopPropagation(); // Prevent row selection on click

  //   const confirmDelete = window.confirm(
  //     "Are you sure you want to inactive this Distributor ?"
  //   );
  //   if (!confirmDelete) return;

  //   try {
  //     setLoading(true);
  //     const payload = {
  //       id: distributorId,
  //       status: newOrderStatus1 == "1" ? 0 : 1
  //     }

  //     const response = await window.Platform.database.deleteDistributor(payload);

  //     window.NotificationUtils.showSuccess(response?.message || "Distributor inactive successfully");

  //     fetchEmployees();
  //   } catch (error) {
  //     console.error("Error inactive Distributor:", error);
  //     window.NotificationUtils.showError("Error inactive Distributor");
  //   } finally {
  //     setLoading(false);
  //   }
  // };



  const approveRejectOrder = async (val) => {
    try {
      setLoading(true);
      if (selectedTab == 0) {
        const payload = {
          id: rejectData,
          status: newOrderStatus == "active" ? "inactive" : "active",
          action_remark: reason
        }
        const response = await window.Platform.database.deleteSchool(payload);

        window.NotificationUtils.showSuccess(response?.message || "Success");

      }
      else {
        const payload = {
          id: rejectData,
          status: newOrderStatus1 == "1" ? 0 : 1,
          action_remark: reason
        }
        const response = await window.Platform.database.deleteDistributor(payload);

        window.NotificationUtils.showSuccess(response?.message || "Success");

      }


      fetchEmployees();
    } catch (error) {
      console.error("Error inactive School:", error);
      window.NotificationUtils.showError("Error Found");
    } finally {
      setLoading(false);
    }
  }

  // const handleDelete = async (schoolId, event) => {
  //   event.stopPropagation(); // Prevent row selection on click

  //   const confirmDelete = window.confirm(
  //     "Are you sure you want to inactive this School?"
  //   );
  //   if (!confirmDelete) return;

  //   try {
  //     setLoading(true);
  //     const payload = {
  //       id: schoolId,
  //       status: newOrderStatus == "active" ? "inactive" : "active"
  //     }
  //     const response = await window.Platform.database.deleteSchool(payload);

  //     window.NotificationUtils.showSuccess(response?.message || "inactive Successfully");

  //     fetchEmployees();
  //   } catch (error) {
  //     console.error("Error inactive School:", error);
  //     window.NotificationUtils.showError("Error Found");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const updateConsent = (data) => {
    consentOtpSend(data);
    setOtpVerify(true);
  };

  const onSubmitOtp = async (data, otp) => {
    try {
      setLoading(true);
      let onsubmitOtp = await window.Platform.database.consentOtpSubmit({
        partyId: data.schoolId,
        otp: otp,
      });

      if (onsubmitOtp.status) {
        setLoading(false);
        window.NotificationUtils.showError(onSubmitOtp.message);
      } else {
        setLoading(false);
        window.NotificationUtils.showSuccess("Consent verified successfully");
        setOtpVerify(false);
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
      window.NotificationUtils.showError("OTP Submission Failed");
    }
  };

  const handleTabChange = async (value, keepSelected = false) => {
    setVisibleEmployees([]);
    if (!keepSelected) {
      setSelectedMember(null);
    }
    setFilter(false);
    setStartDate(null);
    setEndDate(null);

    setDateRange1(false);
    setSelectedTab(value);
  };

  const addNewSchool = () => {
    setSchoolModal(true);

    if (isMobile) {
      scrollToPreview();
    }
  };

  const addNewDistributor = () => {
    setDistributorModal(true);

    if (isMobile) {
      scrollToPreview();
    }
  };



  const fetchAccessModules = async () => {
    try {
      setLoading(true);
      let data = {
        pageNumber: paginationModel.page,
        recordPerPage: paginationModel.pageSize,
        userId: userData?.id,
        moduleId: "rMAeIXw9kl"
      }
      let results = await window.Platform.database.fetchAccessModules(data);
      if (results?.status) {
        window.NotificationUtils.showError(results?.message || "Something went wrong");
        setLoading(false);
        return;
      }
      else {
        const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
        setAccessModulesData(jsonArrayWithId);
      }
    } catch (error) {
      console.error(error);
    }
    finally {
      setLoading(false)
    }
  }



  const fetchEmployees = async () => {
    setLoading(true);

    try {
      setVisibleEmployees([]);
      let results;
      if (selectedTab === 1) {
        results = await window.Platform.database.getDistributor({
          pageNumber: paginationModel1.page,
          recordPerPage: paginationModel1.pageSize,
          filter: search,
          cluster: selectedCluster,
          ownerId: rm,
          district: selectedDistrict,
          pincode: searchPincode,
          // rsm: rsm,
          // asm: asm
          rsm: userData?.role == 'rsm' ? userData?.id : rsm,
          asm: userData?.role == 'asm' ? userData?.id : asm,
          zh: userData?.role == 'zh' ? userData?.id : zh,
          createdByRm: createdByRM ? "rm" : "",
          status: Number(newOrderStatus1)
        });
        setRowCount1(results?.data1);
      } else {
        results = await window.Platform.database.getSchool({
          pageNumber: paginationModel.page,
          filter: search,
          district: selectedDistrict,
          routeName: selectedRouteName,
          pincode: searchPincode,
          recordPerPage: paginationModel.pageSize,
          cluster: selectedCluster,
          ownerId: rm,
          // rsm: rsm,
          // asm: asm,
          rsm: userData?.role == 'rsm' ? userData?.id : rsm,
          asm: userData?.role == 'asm' ? userData?.id : asm,
          zh: userData?.role == 'zh' ? userData?.id : zh,
          createdByRm: createdByRM ? "rm" : "",
          status: newOrderStatus,
          board: board,
          category: category
        });
        setRowCount(results?.data1);
        setNewRows(results?.data)
      }

      const jsonArrayWithId = results?.data?.map((obj, index) => ({
        ...obj,
        id: index + 1,
      }));

      // console.log("results", results);

      // if (auth?.user?.role === ROLES.ADMIN) {
      // console.log("response", results.data);

      // }

      setVisibleEmployees(jsonArrayWithId);
      if (selectAll == "1") {
        const allIds = results?.data?.map((item) => item.schoolId);
        setSelectedSchools((prevSelected) => [...new Set([...prevSelected, ...allIds])]);
      }

      setLoading(false);
      // window.NotificationUtils.showError(results.message)
      if (results.status) {
        setLoading(false);
        window.NotificationUtils.showError(results.message);
      } else {
        setLoading(false);
        // window.NotificationUtils.showSuccess(results.message)
      }
    } catch (error) {
      console.error(error);

      window.NotificationUtils.showError("Error Fetching Data");

      setLoading(false);
    }
  };

  const clearFilter = async () => {
    setHasSearched(false);
    setSearch("");
    setRsm("");
    setAsm("");
    setRm("");
    setZh("");
    setBoard("");
    setCategory("");
    setNewOrderStatus("active")
    setRsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'rsm'));
    setRms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'se'));
    setAsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'asm'));
    setNewOrderStatus1("1")
    setCreatedByRm(false);
    setSelectedCluster("");
    setSearchPincode("");
    setSelectedDistrict("");
    setSelectRouteName("");
    setLoading(true);
    setVisibleEmployees([]);
    setRowCount(0);
    setRowCount1(0);
    setNewRows([]);
    setShowSwapCheck(false);
    setFilter(false);
    setPaginationModel({
      page: 0,
      pageSize: 20,
    });
    // try {
    // setVisibleEmployees([]);
    // let results;
    // if (selectedTab === 1) {
    //   results = await window.Platform.database.getDistributor({
    //     pageNumber: 0,
    //     recordPerPage: 20,
    //     filter: "",
    //     cluster: "",
    //     ownerId: "",
    //     district: "",
    //     pincode: "",
    //     rsm: "",
    //     asm: ""
    //   });
    //   setRowCount1(results?.data1);
    // } else {
    //   // setCreatedByRm(false);
    //   setSelectedCluster("");
    //   setSearchPincode("");
    //   setSelectedDistrict("");
    //   setSelectRouteName("");
    //   results = await window.Platform.database.getSchool({
    //     pageNumber: 0,
    //     filter: "",
    //     district: "",
    //     routeName: "",
    //     pincode: "",
    //     recordPerPage: "",
    //     cluster: "",
    //     ownerId: "",
    //     rsm: "",
    //     asm: "",
    //     createdByRm: ""
    //   });
    //   setRowCount(results?.data1);
    //   setNewRows(results?.data)
    // }

    // const jsonArrayWithId = results?.data?.map((obj, index) => ({
    //   ...obj,
    //   id: index + 1,
    // }));

    // console.log("results", results);

    // if (auth?.user?.role === ROLES.ADMIN) {
    // console.log("response", results.data);

    // }

    // setVisibleEmployees(jsonArrayWithId);
    // if (selectAll == "1") {
    //   const allIds = results?.data?.map((item) => item.schoolId);
    //   setSelectedSchools((prevSelected) => [...new Set([...prevSelected, ...allIds])]);
    // }

    setLoading(false);
    // // window.NotificationUtils.showError(results.message)
    // if (results.status) {
    //   setLoading(false);
    //   window.NotificationUtils.showError(results.message);
    // } else {
    //   setLoading(false);
    //   // window.NotificationUtils.showSuccess(results.message)
    // }
    // } catch (error) {
    // console.error(error);
    // window.NotificationUtils.showError("Error Fetching Data");
    // setLoading(false);
    // }
  };

  const scrollToPreview = () => {
    window.scrollTo(
      0,
      document.getElementById("detailsPreviewContainer").getBoundingClientRect()
        .top
    );
  };

  const onFilterChange = async (filterModel) => {
    try {
      setLoading(true);
      setFilter(true);
      // console.log(filterModel, "filterModel");
      if (filterModel) {
        const response = await window.Platform.database.filterSchool({
          filterField: filterModel.field,
          filterValue: filterModel.value,
          pageNumber: paginationModel.page,
          startDate: startDate,
          endDate: endDate,
        });
        // console.log("respponse", response);
        const jsonArrayWithId = response?.data?.map((obj, index) => ({
          ...obj,
          id: index + 1,
        }));
        setVisibleEmployees(jsonArrayWithId);
        setRowCount(response.data1);
      } else {
        const response = await window.Platform.database.filterSchool({
          filterField: "date",
          pageNumber: paginationModel.page,
          startDate: startDate,
          endDate: endDate,
        });
        // console.log("respponse", response);
        const jsonArrayWithId = response?.data?.map((obj, index) => ({
          ...obj,
          id: index + 1,
        }));
        setVisibleEmployees(jsonArrayWithId);
        setRowCount(response.data1);
      }

      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
      window.NotificationUtils.showError(
        "Error While Recieving Data Please Wait and try again"
      );
    }
  };

  const onFilterChange1 = async (filterModel) => {
    try {
      setLoading(true);
      setFilter(true);
      // console.log(filterModel, "filterModel");
      if (filterModel) {
        const response = await window.Platform.database.filterDistributor({
          filterField: filterModel.field,
          filterValue: filterModel.value,
          pageNumber: paginationModel1.page,
        });
        // console.log("respponse", response);
        const jsonArrayWithId = response?.data?.map((obj, index) => ({
          ...obj,
          id: index + 1,
        }));
        setVisibleEmployees(jsonArrayWithId);
        setRowCount(response.data1);
      } else {
        const response = await window.Platform.database.filterDistributor({
          filterField: "date",
          pageNumber: paginationModel1.page,
          startDate: startDate,
          endDate: endDate,
        });
        // console.log("respponse", response);
        const jsonArrayWithId = response?.data?.map((obj, index) => ({
          ...obj,
          id: index + 1,
        }));
        setVisibleEmployees(jsonArrayWithId);
        setRowCount(response.data1);
      }

      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
      window.NotificationUtils.showError(
        "Error While Recieving Data Please Wait and try again"
      );
    }
  };

  function CustomToolbar() {
    return (
      <div>
        {userData?.role == "super admin" && <GridToolbarContainer>
          <Button className="w-25"
            onClick={() => { setNewOrderStatus("active"); setHasSearched(true) }}
            style={{ backgroundColor: newOrderStatus === "active" ? "green" : "white", color: newOrderStatus === "active" ? "#fff" : "black", fontWeight: "500", }}>
            Active
          </Button>
          <Button className="w-25"
            onClick={() => { setNewOrderStatus("inactive"); setHasSearched(true) }}
            style={{ backgroundColor: newOrderStatus === "inactive" ? "#fb2121ff" : "white", color: newOrderStatus === "inactive" ? "white" : "black", fontWeight: "500", }}>
            InActive
          </Button>
        </GridToolbarContainer>}
      </div>
    );
  }

  function CustomToolbar1() {
    return (
      <div>
        {userData?.role == "super admin" && <GridToolbarContainer>
          <Button className="w-25"
            onClick={() => { setNewOrderStatus1("1"); setHasSearched(true) }}
            style={{ backgroundColor: newOrderStatus1 === "1" ? "green" : "white", color: newOrderStatus1 === "1" ? "#fff" : "black", fontWeight: "500", }}>
            Active
          </Button>
          <Button className="w-25"
            onClick={() => { setNewOrderStatus1("0"); setHasSearched(true) }}
            style={{ backgroundColor: newOrderStatus1 === "0" ? "#fb2121ff" : "white", color: newOrderStatus1 === "0" ? "white" : "black", fontWeight: "500", }}>
            Inactive
          </Button>
        </GridToolbarContainer>}
      </div>
    );
  }

  const swapColumnShow = () => {
    if (showSwapCheck) {
      setSelectedSchools([]);
      setShowSwapCheck(false);
    }
    else {
      setSelectedSchools([]);
      setShowSwapCheck(true);
    }
  }

  const latLongRequestModal = async () => {
    setLetLongRequestModal(true);
  }

  const swapFunctionality = () => {
    setRmForSwap('')
    setOpen(true)
  }

  const handleOkSwap = async () => {
    // Prepare payload same as getSchool plus swap-specific fields
    let data = {
      pageNumber: paginationModel.page,
      filter: search,
      district: selectedDistrict,
      routeName: selectedRouteName,
      pincode: searchPincode,
      recordPerPage: paginationModel.pageSize,
      cluster: selectedCluster,
      ownerId: rm,
      rsm: rsm,
      asm: asm,
      selectOwnerId: rm,
      selectedSchools: selectAll,
      ownerIdArr: selectedSchools,
      updateOwnerId: rmForSwap
    };

    // console.log(data,"datashaoJIDHQJDASJDHASD")
    //  return;
    let results = await window.Platform.database.swipeOwnerIdForSchool(data);
    if (results) {
      window.NotificationUtils.showSuccess("RM Swaped SuccessFully");
      fetchEmployees();
      setSelectedSchools([]);
      // setShowSwapCheck(false)
    }

    setOpen(false);
  }


  const renderTabContent = () => {

    if (selectedTab === 0) {
      return (<>
        {/* <div>
        <Button onClick={()=>{swapColumnShow()}}>Swap</Button>
        <Button onClick={()=>{swapFunctionality()}}>New Swap</Button>
      </div> */}
        <Modal open={open} onClose={() => setOpen(false)} aria-labelledby="swap-modal">
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "40%",
              bgcolor: "white",
              boxShadow: 24,
              p: 3,
              borderRadius: 2,
              textAlign: "center",
            }}
          >
            <Typography id="swap-modal" variant="h6" mb={2}>
              Swap
            </Typography>

            {/* RM Dropdown */}
            <Select
              value={rmForSwap}
              onChange={(e) => setRmForSwap(e.target.value)}
              fullWidth
              displayEmpty
            >
              <MenuItem value="">Select RM</MenuItem>
              {proceedRms.map((role) => (
                <MenuItem key={role.id} value={role.id}>
                  {role.name}
                </MenuItem>
              ))}
            </Select>

            {/* Buttons */}
            <Box mt={2} gap={3} display="flex" justifyContent="center">
              <Button variant="contained" color="secondary" onClick={() => handleOkSwap()}>
                Ok
              </Button>
              <Button variant="contained" color="secondary" onClick={() => setOpen(false)}>
                Close
              </Button>
            </Box>
          </Box>
        </Modal>
        <div className="d-flex justify-content-end align-items-center  py-2">
          {/* <Button onClick={() => { latLongRequestModal() }} variant="contained" color="success" className="mr-4">Lat Long Request</Button> */}
          {selectedTab == 0 && <div className="mr-3">
            {
              createdByRM ? <Button variant="contained" color="primary" onClick={() => { setCreatedByRm(false) }}>
                Back To All School
              </Button>
                :
                <Button variant="contained" color="info" onClick={() => { setCreatedByRm(true) }}>
                  Created By RM
                </Button>
            }
          </div>}
          <div>
            {showSwapCheck ?
              <>
                <Button className="mr-3" onClick={() => { swapFunctionality() }} variant="contained" color="primary" >Proceed</Button>
                <Button className="mr-4" variant="contained" color="primary" onClick={() => { setShowSwapCheck(false) }}>Cancel</Button>
              </>
              :
              <>
                {userData?.role == "super admin" && <Button onClick={() => { swapColumnShow() }} variant="contained" color="primary" className="mr-4">Swap</Button>}
              </>
            }

          </div>
          <Typography variant="body1" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select Page Size:&nbsp; </Typography>
          <Select
            value={paginationModel.pageSize}
            variant="outlined"
            size="small"
            onChange={(e) => { setHasSearched(true); setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
            sx={{ width: 90, fontSize: 13, fontWeight: "500" }}
          >
            {[10, 20, 30, 50, 100].map((role) => (
              <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role}</MenuItem>
            ))}
          </Select>
        </div>
        <DataGridContainer
          style={{ height: !visibleEmployees.length ? "200px" : "auto" }}
        >
          <DataGrid
            className="payrollGrid"
            // checkboxSelection={true}
            density="compact"
            rows={visibleEmployees || []}
            columns={schoolColumns()}
            sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
            // disableSelectionOnClick

            disableSelectionOnClick
            disableRowSelectionOnClick

            onRowClick={(rowParams, event) => {
              setUserModal(rowParams.row);
              // console.log(rowParams.onRowClick);
            }}
            rowHeight={60}
            pageSizeOptions={[10]}
            rowCount={rowCount}
            paginationModel={paginationModel}
            paginationMode="server"
            onPaginationModelChange={setPaginationModel}
            components={{
              Toolbar: CustomToolbar,
            }}

          />
        </DataGridContainer>
      </>
      );
    } else if (selectedTab === 1) {
      return (
        <>
          <div className="d-flex justify-content-end align-items-center  py-2">
            <div className="mr-3">
              {
                createdByRM ? <Button variant="contained" color="primary" onClick={() => { setCreatedByRm(false) }}>
                  Back To All Distributor
                </Button>
                  :
                  <Button variant="contained" color="info" onClick={() => { setCreatedByRm(true) }}>
                    Created By RM
                  </Button>
              }
            </div>
            <Typography variant="body1" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select Page Size:&nbsp; </Typography>
            <Select
              value={paginationModel1.pageSize}
              variant="outlined"
              size="small"
              onChange={(e) => { setPaginationModel1({ ...paginationModel1, pageSize: e.target.value }); setHasSearched(true) }}
              sx={{ width: 90, fontSize: 14, fontWeight: "500" }}
            >
              {[10, 20, 30, 50, 100].map((role) => (
                <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role}</MenuItem>
              ))}
            </Select>
          </div>
          <DataGridContainer
            style={{ height: !visibleEmployees?.length ? "200px" : "auto" }}
          >
            <DataGrid
              className="payrollGrid"
              // checkboxSelection={true}
              density="compact"
              rows={visibleEmployees || []}
              columns={distributorColumn()}
              sx={{ color: "black", fontSize: "13px", fontWeight: "600" }}
              // disableSelectionOnClick

              disableSelectionOnClick
              disableRowSelectionOnClick
              pageSizeOptions={[10]}
              onRowClick={(rowParams, event) => {
                setUserModal(rowParams.row);
                // console.log(rowParams.onRowClick);
              }}
              rowHeight={60}

              filterMode="server"
              rowCount={rowCount1}
              paginationModel={paginationModel1}
              paginationMode="server"
              onPaginationModelChange={setPaginationModel1}
              components={{
                Toolbar: CustomToolbar1,
              }}

            />
          </DataGridContainer>
        </>
      );
    }
  };



  const onClose = async (data) => {
    // console.log("COMMONOTPMODAL", data.makerContact);
    try {
      // const response = await window.Platform.database.sendOtp({ mobile: data.makerContact })
      // window.NotificationUtils.showSuccess("OTP Sent Successfully");

      setOtpModalData(data);
      submitOtp(data);
      // setOtpModal1(true)
      // setSchoolModal(false)
      // setEditSchool(false)
    } catch (error) {
      console.log(error);
    }
  };

  const onCloseDistributor = async (data) => {
    // console.log("COMMONOTPMODAL", data.makerContact);
    try {
      // const response = await window.Platform.database.sendOtp({ mobile: data.makerContact })
      // window.NotificationUtils.showSuccess("OTP Sent Successfully");

      setOtpModalDataDistributor(data);
      submitOtpDistributor(data);
      // setOtpModalDistributor(true)
      // setDistributorModal(false)
      // setEditSchool(false)
    } catch (error) {
      console.log(error);
    }
  };

  const resendOTP = async (data) => {
    try {
      setLoading(true);
      const response = await window.Platform.database.resendOTP({
        mobile: otpModalData.makerContact,
      });

      setLoading(false);
      window.NotificationUtils.showSuccess("OTP Sent Successfully");

      // setDistributorModal(false)
      // setEditSchool(false)
    } catch (error) {
      console.log(error);
    }
  };
  const getClusterInPicklist = async () => {
    setLoading(true);
    try {
      let results = await window.Platform.database.getClusterInPicklist();

      const jsonArrayWithId = results?.data?.map((obj) => ({
        ...obj,
        dbId: obj.id
      }));


      setClusters(jsonArrayWithId);
      setLoading(false);
    } catch (error) {
      console.error("ERRORCHECK", error);
      setLoading(false);
    }
  };

  const allDistrictsDropdown = async () => {
    setLoading(true);

    let results = await window.Platform.database.getAllDistricts();
    if (results?.status) {
      setAllDistricts(results?.data)
      setLoading(false);
    }
    else {
      setLoading(false);
      window.NotificationUtils.showError("Error In fetching districts");
    }

  }

  const getAllRouteNames = async () => {
    setLoading(true);

    let results = await window.Platform.database.getAllRouteNames();
    if (results?.status) {
      // const mappedRoutes = results.data.map((route) => ({ name: route }));
      setAllRouteNames(results?.data);
      setLoading(false);
    }
    else {
      setLoading(false);
      window.NotificationUtils.showError("Error In fetching Route Name");
    }

  }

  const resendOTPDistributor = async (data) => {
    try {
      setLoading(true);
      const response = await window.Platform.database.resendOTP({
        mobile: otpModalDataDistributor.makerContact,
      });

      setLoading(false);
      window.NotificationUtils.showSuccess("OTP Sent Successfully");

      // setDistributorModal(false)
      // setEditSchool(false)
    } catch (error) {
      console.log(error);
    }
  };

  const submitOtp = async (data) => {
    try {
      setLoading(true);
      const response1 = await window.Platform.database.addSchool(data);
      if (response1.status) {
        window.NotificationUtils.showError(response1.message);
        // setSchoolModal(false);
        setLoading(false);
        return;
      } else {
        window.NotificationUtils.showSuccess(response1.message);
        fetchEmployees();
        setLoading(false);
        setSchoolModal(false);
        // window.NotificationUtils.showSuccess("Party Added Successfully");
      }
      // setSchoolModal(false);
      // setLoading(false);
      // fetchEmployees();
      // window.NotificationUtils.showSuccess("Party Added Successfully");
    } catch (error) {
      console.log(error);
      setLoading(false);
      window.NotificationUtils.showError("Something went wrong");
      // if (error.message.includes("ER_DUP_ENTRY")) {
      //   window.NotificationUtils.showError("Duplicate school ID detected. Please use a unique school ID.");
      // } else {
      //   window.NotificationUtils.showError("Duplicate school ID detected. Please use a unique school ID.");
      // }
    }
  };

  // const submitOtp = async (data) => {
  //   try {
  //     // const response = await window.Platform.database.verifyOtp({ otp: data, mobile: otpModalData.makerContact })
  //     // if (response.status === true) {
  //     //     window.NotificationUtils.showError(response.message);
  //     //     setLoading(false)

  //     //     return;
  //     // }
  //     // setOtpModal1(false)
  //     setLoading(true);
  //     const response1 = await window.Platform.database.addSchool(data);
  //     if (response1.status === true) {
  //       window.NotificationUtils.showError(response1.message);
  //       setSchoolModal(false);
  //       setLoading(false);

  //       return;
  //     }
  //     else{
  //       setSchoolModal(false);
  //       setLoading(false);
  //       window.NotificationUtils.showError(response1.message);
  //       setLoading(false);
  //     }
  //     setSchoolModal(false);
  //     setLoading(false);
  //     fetchEmployees();
  //     window.NotificationUtils.showSuccess("Party Added Successfully");
  //   } catch (error) {
  //     console.log(error);
  //     setLoading(false);
  //   }
  // };
  const submitOtpDistributor = async (data) => {
    try {
      // const response = await window.Platform.database.verifyOtp({ otp: data, mobile: otpModalDataDistributor.makerContact })
      // if (response.status === true) {
      //     window.NotificationUtils.showError(response.message);
      //     setLoading(false)

      //     return;
      // }
      // setOtpModalDistributor(false)

      setLoading(true);
      const results = await window.Platform.database.addDistributor(data);
      if (results.status === true) {
        window.NotificationUtils.showError(results.message);
        setLoading(false);

        return;
      }

      setDistributorModal(false);
      setLoading(false);
      fetchEmployees();
      window.NotificationUtils.showSuccess("Party Added Successfully");
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };


  const exportSchool = async () => {
    setLoading(true);
    try {
      let data = {
        // pageNumber: paginationModel.page,
        // filter: search,
        // recordPerPage: paginationModel.pageSize,
        // cluster: selectedCluster,
        // ownerId: rm,
        // rsm: rsm,
        // asm: asm
        pageNumber: paginationModel.page,
        filter: search,
        district: selectedDistrict,
        routeName: selectedRouteName,
        pincode: searchPincode,
        recordPerPage: paginationModel.pageSize,
        cluster: selectedCluster,
        ownerId: rm,
        // rsm: rsm,
        // asm: asm,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
        asm: userData?.role == 'asm' ? userData?.id : asm,
        createdByRm: createdByRM ? "rm" : ""
      };

      // const result = await axiosInstance.post(

      // data,
      // {
      //     responseType: "blob",
      //     Token : 'token='+localStorage.getItem("token")
      // }
      // );

      let result = await window.Platform.database.exportData("/party/exportSchool",
        data
      )

      // Check if the response is actually a Blob
      // console.log(result, "API Response Data");

      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "school.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  };


  const exportDistributor = async () => {
    setLoading(true);
    try {
      let data = {
        filter: search,
        cluster: selectedCluster,
        ownerId: rm,
        // rsm: rsm,
        // asm: asm
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
        asm: userData?.role == 'asm' ? userData?.id : asm
      };

      let result = await window.Platform.database.exportData("/party/exportDistributor",
        data
      )

      // Check if the response is actually a Blob
      // console.log(result, "API Response Data");

      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "distributors.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  };

  return (
    <>
      <StaffEditorPageContainer>
        <HeaderContainer>
          <Box sx={{ mt: 1, width: "100%" }}>

            <Paper elevation={3}
              sx={{
                p: 2,
                mb: 2,
                width: '100%',        // takes full width of parent
                // maxWidth: '1000px',   // optional: control max width
                mx: 'auto',
                backgroundColor: "#ebf0fa"          // center it horizontally
              }}>
              <div className="container-fluid" style={{ width: "100%" }}>
                <div className="row">
                  {userData?.role.includes('admin') && <div className="col-md-3">
                    <FormControl fullWidth size="small">
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select HO</InputLabel>
                      <Select
                        value={rsm}
                        label="Select HO"
                        sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                        size="small"
                        onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value); setAsm(""); setRm(""); setZh(""); }}
                      >
                        <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                        {rsms.map((role) => (
                          <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                  </div>}
                  {(userData?.role != 'zh' || userData?.role != 'asm') && <div className="col-md-3">
                    <FormControl size="small" fullWidth>
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select ZH</InputLabel>
                      <Select
                        value={zh}
                        sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                        label="Select ZH"
                        size="small"
                        onChange={(e) => { setZh(e.target.value); getUsers('zh', e.target.value); setRm(""); setAsm(""); }}
                      >
                        <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                        {zhs?.map((role) => (
                          <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>}
                  {userData?.role != 'asm' && <div className="col-md-3">
                    <FormControl size="small" fullWidth>
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select ARM</InputLabel>
                      <Select
                        value={asm}
                        sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                        label="Select ARM"
                        size="small"
                        onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value); setRm("") }}
                      >
                        <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                        {asms.map((role) => (
                          <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>}
                  <div className="col-md-3">
                    <FormControl size="small" fullWidth>
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select RM:</InputLabel>
                      <Select
                        value={rm}
                        label="Select RM"
                        size="small"
                        sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                        onChange={(e) => { setRm(e.target.value) }}
                      >
                        <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                        {rms.map((role) => (
                          <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                {selectedTab == 0 && <div className="row mt-2">
                  <div className="col-md-3">
                    <FormControl size="small" fullWidth>
                      <TextField
                        label="Search By Id, Name, Address, Board, Category"
                        size="small"
                        value={search}
                        placeholder="Search By Id, Name, Address, Board, Category"
                        className="form-control"
                        onChange={(e) => setSearch(e.target.value)}
                        sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                        InputLabelProps={{
                          shrink: true,
                          style: { color: "black", fontSize: "14px", fontWeight: 500 }
                        }}
                        inputProps={{
                          style: { color: "black", fontSize: "14px", fontWeight: 500 }
                        }}
                      />
                    </FormControl>
                  </div>
                  <div className="col-md-3">
                    <FormControl size="small" fullWidth>
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Board</InputLabel>
                      <Select
                        value={board}
                        label="Select Board"
                        size="small"
                        sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                        onChange={(e) => { setBoard(e.target.value) }}
                      >
                        <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                        {boards.map((ele, ind) => (
                          <MenuItem key={ind} value={ele.boardId} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{ele.boardName} </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="col-md-3">
                    <FormControl size="small" fullWidth>
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Category</InputLabel>
                      <Select
                        value={category}
                        label="Select Category"
                        size="small"
                        sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                        onChange={(e) => { setCategory(e.target.value) }}
                      >
                        <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                        {categories.map((ele, ind) => (
                          <MenuItem key={ind} value={ele.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{ele.name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="col-md-3">
                    {/* <> */}
                    <FormControl fullWidth size="small">
                      <TextField
                        label="Pincode"
                        size="small"
                        value={searchPincode}
                        placeholder="Enter Pincode"
                        className="form-control"
                        onChange={(e) => setSearchPincode(e.target.value)}
                        sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                        InputLabelProps={{
                          shrink: true,
                          style: { color: "black", fontSize: "14px", fontWeight: 500 }
                        }}
                        inputProps={{
                          style: { color: "black", fontSize: "14px", fontWeight: 500 }
                        }}
                      />
                    </FormControl>
                  </div>

                </div>}
                <div className="row mt-2">
                  {selectedTab == 0 &&
                    <><div className="col-md-3">
                      <FormControl fullWidth size={"small"}>
                        <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select District</InputLabel>
                        <Select
                          value={selectedDistrict}
                          size="small"
                          label="Select District"
                          onChange={(e) => { setSelectedDistrict(e.target.value) }}
                          sx={{ fontWeight: "500", color: "black" }}
                        >
                          <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                          {allDistricts?.map((role) => (
                            <MenuItem key={role} value={role.District} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.District}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                      <div className="col-md-3">
                        <FormControl size="small" fullWidth>
                          <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Area </InputLabel>
                          <Select
                            label="Select Area"
                            value={selectedCluster}
                            size="small"
                            sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                            onChange={(e) => { setSelectedCluster(e.target.value) }}
                          >
                            <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                            {clusters.map((role) => (
                              <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                      <div className="col-md-3">
                        <FormControl fullWidth size={"small"}>
                          <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Route Name</InputLabel>
                          <Select
                            value={selectedRouteName}
                            size="small"
                            label="Select Route Name"
                            onChange={(e) => { setSelectRouteName(e.target.value) }}
                            sx={{ fontWeight: "500", color: "black" }}
                          >
                            <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>{console.log(allRouteNames, "allRouteNames")}
                            {allRouteNames?.map((role) => (
                              <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    </>}
                  {selectedTab == 1 && <div className="col-md-3">
                    <FormControl size="small" fullWidth>
                      <TextField
                        label="Search By Id, Name, Address"
                        size="small"
                        value={search}
                        placeholder="Search By Id, Name, Address"
                        className="form-control"
                        onChange={(e) => setSearch(e.target.value)}
                        sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                        InputLabelProps={{
                          shrink: true,
                          style: { color: "black", fontSize: "14px", fontWeight: 500 }
                        }}
                        inputProps={{
                          style: { color: "black", fontSize: "14px", fontWeight: 500 }
                        }}
                      />
                    </FormControl>
                  </div>}
                  <div className="col-md-3">
                    <Button variant="contained" color="primary" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => { setHasSearched(true); fetchEmployees() }}>
                      Find
                    </Button>
                  </div>
                  <div className="col-md-3 mt-2">
                    {selectedTab == 0 ? <Button variant="contained" startIcon={<img src={clearFilterImage} alt="icon" height={"21"} width={"21"} />} color="secondary" fullWidth sx={{ borderRadius: "10px" }} onClick={() => { clearFilter() }}>Clear Filters</Button> : <Button variant="contained" startIcon={<img src={clearFilterImage} alt="icon" height={"21"} width={"21"} />} color="secondary" fullWidth sx={{ borderRadius: "10px" }} onClick={() => { clearFilter() }}>Clear Filters</Button>}
                  </div>
                  {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" && <div className="col-md-3 mt-2">
                    {selectedTab == 0 ? <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ borderRadius: "10px" }} onClick={() => { exportSchool() }}>Download</Button> : <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ borderRadius: "10px" }} onClick={() => { exportDistributor() }}>Download</Button>}
                  </div>}
                </div>

              </div>
            </Paper>
            {accessModulesData && accessModulesData[0]?.is_add?.toLowerCase() != "no" && <Box display="flex" justifyContent="flex-end" gap={2}>

              {/* <div className="row"> */}
              <div className="col-md-3">
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  onClick={
                    selectedTab === 0
                      ? () => setBulkSchool(true)
                      : () => setBulkDistributor(true)
                  }
                  sx={{ borderRadius: "10px" }}
                >
                  {/* <Add sx={{ mr: 1 }} /> */}
                  <DriveFolderUploadIcon sx={{ mr: 1 }} />
                  {selectedTab === 0 ? "Bulk Add School" : "Bulk Add Distributor"}
                </Button>
              </div>
              <div className="col-md-3">
                <Button
                  // variant="contained"
                  // fullWidth
                  // color="primary"
                  // onClick={selectedTab === 0 ? addNewSchool : addNewDistributor}
                  variant="contained"
                  fullWidth
                  color="primary"
                  onClick={() => {
                    if (selectedTab === 0) {
                      navigate("/school"); // 🟢 Open full page for school
                    } else {
                      navigate("/distribution"); // Keep old logic for distributor
                    }
                  }}
                  sx={{ borderRadius: "10px" }}
                >
                  <Add />
                  {selectedTab === 0 ? "Add School" : "Add Distributor"}
                </Button>
              </div>

              {/* </div> */}
            </Box>}
          </Box>
          {/* bsss */}
        </HeaderContainer>
        <TableContainer>
          <TabsContainer>
            <StyledTabs
              variant="fullWidth"
              value={selectedTab}
              onChange={(event, value) => handleTabChange(value)}
              indicatorColor="none"
              textColor="primary"
            >
              <Tab label="School"  sx={{ fontSize: "15px", color: "#000", fontWeight:"600", backgroundColor: selectedTab == 0 ? "#fff" : "#e6e3e3de " }} />

              {<Tab label="Distributor"  sx={{ fontSize: "15px", color: "#000", fontWeight:"600", backgroundColor: selectedTab == 1 ? "#fff" : "#e6e3e3de " }} />}
            </StyledTabs>
            {loading && <OpaqueLoading />}

            {renderTabContent()}
          </TabsContainer>
        </TableContainer>
      </StaffEditorPageContainer>

      {otpVerify && (
        <CommonOtpModalConsent
          data={consentData}
          closeModal={() => setOtpVerify(false)}
          onClickSubmit={onSubmitOtp}
          resendOTP={consentOtpResend}
        />
      )}
      {schoolModal && (
        <SchoolModal
          onClose1={(data) => onClose(data)}
          onClose={() => setSchoolModal(false)}
          fetchData={() => fetchEmployees()}
          status={true}
        />
      )}
      {distributorModal && (
        <DistributorModal
          onClose={() => setDistributorModal(false)}
          onClose1={(data) => onCloseDistributor(data)}
          fetchData={() => fetchEmployees()}
          status={true}
        />
      )}

      {editSchool && (
        <SchoolModal
          onClose={() => setEditSchool(false)}
          fetchData={() => fetchEmployees()}
          dataProp={editData}
          status={false}
        />
      )}
      {editDistributor && (
        <DistributorModal
          onClose={() => setEditDistributor(false)}
          fetchData={() => fetchEmployees()}
          dataProp={editData1}
          status={false}
        />
      )}
      {otpModal1 && (
        <CommonOtpModal
          closeModal={() => setOtpModal1(false)}
          onClickSubmit={(data) => submitOtp(data)}
          resendOTP={() => resendOTP()}
        />
      )}

      {otpmModalDistributor && (
        <CommonOtpModal
          closeModal={() => setOtpModalDistributor(false)}
          onClickSubmit={(data) => submitOtpDistributor(data)}
          resendOTP={() => resendOTPDistributor()}
        />
      )}

      {bulkSchool && (
        <BulkAddSchool
          onClose={() => setBulkSchool(false)}
          fetchData={() => fetchEmployees()}
        />
      )}
      {bulkDistributor && (
        <BulkAddDistributor
          onClose={() => setBulkDistributor(false)}
          fetchData={() => fetchEmployees()}
        />
      )}
      {letLongRequestModal && (
        <LatLongRequestModal
          onClose={() => setLetLongRequestModal(false)}
        // fetchData={() => fetchEmployees()}
        />
      )}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
        <DialogTitle>Party Remark</DialogTitle>
        <DialogContent>
          Party ID :- {rejectData}
          <TextField autoFocus margin="dense" label="Remark" type="text" fullWidth variant="outlined" value={reason} onChange={(e) => setReason(e.target.value)} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmReject} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PartyManagement;
